import { defineComponent as _defineComponent } from 'vue'
import { UserDB } from '@/enitites/user'
import BKButton from '@/components/AppShared/BKButton.vue'
import useValidationRules from '@/shared/composables/validation'
import { ref } from 'vue'
import { useCloned } from '@vueuse/core'
import OnboardingFormLayout from './OnboardingFormLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingBirthdayForm',
  props: {
    currentStep: { default: 0 },
    error: { default: '' },
    loading: { type: Boolean, default: false },
    steps: { default: 0 },
    user: null
  },
  emits: ["goBack", "submitForm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'goBack'): void
  (e: 'submitForm', value: UserDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentStep: number, error: string, loading: boolean, steps: number, user: UserDB };



const user = ref(useCloned(props.user).cloned)



const rules = useValidationRules()
const mask = '##/##/####'
const valid = ref(true)

return { __sfc: true,props, user, emit, rules, mask, valid, BKButton, OnboardingFormLayout }
}

})